import { ArrowRight } from "lucide-react"

type City = {
  id: number
  name: string
  slug: string
  report_count: number
  last_report_at: string | null
}

type CityGroup = {
  country_code: string
  country_name: string
  cities: City[]
}

type Props = {
  city_groups: CityGroup[]
}

export default function CitiesDirectory({ city_groups }: Props) {
  return (
    <main className="ch-noise relative z-10 flex-grow selection:bg-[hsl(var(--ch-primary))] selection:text-white">
      <section className="ch-container py-14 md:py-16">
        <div className="mb-10 text-center">
          <h1 className="ch-masthead mb-3 text-[hsl(var(--ch-primary))]">City Silos</h1>
          <p className="mx-auto max-w-2xl text-sm leading-relaxed text-[hsl(var(--ch-muted))]">
            Browse all tracked municipalities by country. Cities are listed alphabetically with report totals and most
            recent publication time.
          </p>
        </div>

        <div className="space-y-10">
          {city_groups.map((group) => (
            <section key={group.country_code || group.country_name}>
              <div className="mb-4 flex items-center justify-between border-b border-[hsl(var(--ch-primary))] pb-2">
                <h2 className="ch-headline-md uppercase text-[hsl(var(--ch-primary))]">{group.country_name}</h2>
                <span className="ch-label-caps text-[hsl(var(--ch-muted))]">{group.country_code}</span>
              </div>

              <div className="grid grid-cols-1 gap-0 border border-[hsl(var(--ch-primary))] sm:grid-cols-2 lg:grid-cols-3">
                {group.cities.map((city) => (
                  <a
                    key={city.id}
                    className="group flex min-h-[220px] flex-col justify-between border-b border-r border-[hsl(var(--ch-primary))] p-6 transition-colors hover:bg-[hsl(var(--ch-surface))]"
                    href={`/cities/${city.slug}`}
                  >
                    <div>
                      <span className="ch-label-caps mb-2 block text-[hsl(var(--ch-muted))]">Municipal Desk</span>
                      <h3 className="ch-headline-md uppercase text-[hsl(var(--ch-primary))] group-hover:underline">{city.name}</h3>
                    </div>
                    <div className="space-y-2 text-sm text-[hsl(var(--ch-muted))]">
                      <p>
                        <span className="ch-label-caps mr-2 text-[hsl(var(--ch-primary))]">Reports</span>
                        {city.report_count}
                      </p>
                      <p>
                        <span className="ch-label-caps mr-2 text-[hsl(var(--ch-primary))]">Last Report</span>
                        {city.last_report_at ? new Date(city.last_report_at).toLocaleString() : "No reports yet"}
                      </p>
                      <div className="mt-2 flex items-end justify-end">
                        <ArrowRight className="h-5 w-5 text-[hsl(var(--ch-primary))] transition-transform group-hover:translate-x-1" />
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </section>
          ))}
        </div>
      </section>
    </main>
  )
}
